var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.accountingPointsPU.accountingPointsPU),function(equipment,i){return _c('equipment-list-card',{key:i,attrs:{"equipment":equipment,"asd":_vm.getObjectAsd(equipment)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }